import { render, staticRenderFns } from "./modal-winter-real-rewards.vue?vue&type=template&id=1f3c06f7"
import script from "./modal-winter-real-rewards.vue?vue&type=script&lang=js"
export * from "./modal-winter-real-rewards.vue?vue&type=script&lang=js"
import style0 from "./modal-winter-real-rewards.vue?vue&type=style&index=0&id=1f3c06f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports